const CUSTOM_PERMISSION_GROUP_ADDED = 'Custom Permission Group Added';
const CUSTOM_PERMISSION_GROUP_EDITED = 'Custom Permission Group Edited';
const CUSTOM_PERMISSION_GROUP_DELETED = 'Custom Permission Group Deleted';

export {
  CUSTOM_PERMISSION_GROUP_ADDED,
  CUSTOM_PERMISSION_GROUP_EDITED,
  CUSTOM_PERMISSION_GROUP_DELETED,
};
